import { getReaderEnvironment } from '../api/readerApi';

const PLACEHOLDER_PREFIX = 'REPLACE_WITH_PROD_';

const AUTH_CONFIG = {
  labs: {
    authority: 'https://cognito-idp.us-west-2.amazonaws.com/us-west-2_z4QYL4ynT',
    clientId: '5147jo08m8a4dv5ofmre8d4fit',
    hostedDomain: 'https://jeshua-readers-labs.auth.us-west-2.amazoncognito.com'
  },
  prod: {
    authority: `https://cognito-idp.${PLACEHOLDER_PREFIX}REGION.amazonaws.com/${PLACEHOLDER_PREFIX}USER_POOL_ID`,
    clientId: `${PLACEHOLDER_PREFIX}READER_CLIENT_ID`,
    hostedDomain: `https://${PLACEHOLDER_PREFIX}READER_HOSTED_DOMAIN`
  }
};

export const getAuthConfig = () => AUTH_CONFIG[getReaderEnvironment()];

export const isAuthConfigured = (config = getAuthConfig()) =>
  !Object.values(config).some((value) => value.includes(PLACEHOLDER_PREFIX));
